import { render, staticRenderFns } from "./CustomTable1.vue?vue&type=template&id=346dd784&scoped=true"
import script from "./CustomTable1.vue?vue&type=script&lang=js"
export * from "./CustomTable1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346dd784",
  null
  
)

export default component.exports